export function validateShipping({ street1, restrictedAddressValue }: any = {}) {
  for (let value of restrictedAddressValue ?? []) {
    const address = street1?.toLowerCase()?.replaceAll(' ', '')
    value = value?.toLowerCase()?.replaceAll(' ', '')
    if (address?.includes(value)) {
      throw new Error('Address invalid. We do not deliver to PO Boxes')
    }
  }
}
